"use strict";

// Pretty stringify
module.exports = function stringify(obj) {
  return JSON.stringify(obj, null, 2);
};


//////////////////
// WEBPACK FOOTER
// ./~/lowdb/adapters/_stringify.js
// module id = 1161
// module chunks = 0